import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { AxiosInstance } from 'axios';
import {
    IContraventionReScanHttpController,
    IGetCameraValidDate,
    IGetGroupIdsByProcessingJob,
    IReScanGeneratePCN,
    ITransferToQueue,
} from '../IContraventionReScanHttpController';
import { ContraventionProcessingJob } from '../../model/ContraventionProcessingJob';

export class ContraventionReScanHttpController
    extends BaseHttpController<ContraventionProcessingJob>
    implements IContraventionReScanHttpController
{
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'contravention-rescan', client);
    }

    async reScanGeneratePCN(props: IReScanGeneratePCN): Promise<boolean> {
        return await this.doPost({ path: 're-scan-generate-pcn', body: props }).then((res) => res.data);
    }

    async transferToQueue(props: ITransferToQueue): Promise<boolean> {
        return await this.doPost({ path: 'transfer-to-queue', body: props }).then((res) => res.data);
    }

    async getValidDateRange(props: IGetCameraValidDate): Promise<{ fromDate: Date; toDate: Date }> {
        return await this.doPost({ path: 'get-valid-date-range', body: props }).then((res) => res.data);
    }

    async getGroupIdsByProcessingJob(props: IGetGroupIdsByProcessingJob): Promise<number[]> {
        return await this.doPost({ path: 'next', body: props }).then((res) => res.data);
    }
}
